import { isProd } from '@forchange/utils';

const baseUrl = isProd()
  ? `https://${window.location.host}/client/playground#/`
  : 'https://forchange-test.cleword.cn/playground#/';

export function getSandboxIframeUrl(content: any) {
  const options: { [key: string]: string | undefined } = {
    userType: 'cleword',
    holderType: window.location.host,
    type: content.type,
    zip: content.zip,
    code: content.code,
    file: content.file || (content.type === 'pc-normal' ? 'main.py' : 'main.ipynb'),
    path: btoa(encodeURIComponent(content.$id))
  };

  const queryUrl = Object.keys(options)
    .filter((key) => options[key])
    .map((key) => {
      return key + '=' + encodeURIComponent(options[key] || '');
    })
    .join('&');

  return `${baseUrl}?${queryUrl}`;
}
